import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CustomProvider, ReCaptchaEnterpriseProvider, } from '@angular/fire/app-check';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaBrowserService {

  constructor(
    @Inject(PLATFORM_ID) private platformId: string
) { }

  provider(siteKey: string) {
    if(!environment.production && isPlatformBrowser(this.platformId)) {
      self.FIREBASE_APPCHECK_DEBUG_TOKEN = "5E0FE860-CBF5-44CF-BD33-368C8C9D3BD8";
    }
    return isPlatformBrowser(this.platformId)
        ? new ReCaptchaEnterpriseProvider(siteKey)
        : new CustomProvider({
            getToken: () => new Promise(() => { })
        })
  }
}